import { useStore } from "@/store/AppStore";
import { PageHeader, Panel, ProgressLine, Tag, attTone } from "@/components/kit";
import { BarsChart, GOLD } from "@/components/Charts";
import { RankingTable } from "@/components/Lists";
import { ranking, inMonth } from "@/lib/selectors";
import { goalResult } from "@/lib/tasks";
import { PROFILES, MONTH_LABEL } from "@/data/mock";
import { brl, fmtDate } from "@/lib/format";

export default function CollabGoals() {
  const { state } = useStore();
  const { collaboratorId, companyId } = PROFILES.colaboradora;
  const rows = ranking(state, companyId);
  const me = rows.find((r) => r.id === collaboratorId);
  const entries = state.sales.filter((e) => e.collaboratorId === collaboratorId && inMonth(e)).sort((a, b) => a.date.localeCompare(b.date));

  return (
    <div data-testid="collab-goals-page">
      <PageHeader eyebrow={MONTH_LABEL} title="Minhas metas" subtitle="Vendas lançadas pela gestora a partir do sistema da empresa." />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Panel title="Meta de vendas" testId="collab-goal-panel">
          <p data-testid="collab-sales-value" className="font-display text-4xl font-semibold">{brl(me.sales)}</p>
          <p className="mt-1 text-sm text-neutral-500">de {brl(me.goal)}</p>
          <div className="mt-5"><ProgressLine value={me.att} /></div>
          <div className="mt-4 flex items-center justify-between"><Tag tone={attTone(me.att)}>{me.att}% atingido</Tag><span className="text-xs text-neutral-500">Faltam {brl(Math.max(me.goal - me.sales, 0))}</span></div>
          <div className="mt-8 border-t border-neutral-100 pt-6">
            <p className="text-xs uppercase tracking-widest text-neutral-400">Tarefas concluídas</p>
            <p className="mt-1 font-display text-2xl font-semibold">{me.tasks}%</p>
          </div>
        </Panel>
        <Panel title="Vendas por dia" subtitle="Lançamentos do mês" className="lg:col-span-2" testId="collab-sales-chart">
          <BarsChart data={entries.map((e) => ({ dia: fmtDate(e.date), valor: e.value }))} xKey="dia" series={[{ key: "valor", name: "Vendas", color: GOLD }]} />
        </Panel>
      </div>
      <Panel title="Metas operacionais" subtitle="Suas metas e as metas da equipe" className="mt-6" testId="collab-ops-goals">
        <ul className="divide-y divide-neutral-100">
          {state.goals.filter((g) => g.companyId === companyId && (!g.collaboratorId || g.collaboratorId === collaboratorId)).map((g) => {
            const { value, att } = goalResult(state, g);
            return (
              <li key={g.id} data-testid={`collab-goal-${g.id}`} className="flex flex-wrap items-center gap-3 py-3.5">
                <div className="min-w-0 flex-1"><p className="text-sm font-semibold">{g.title}</p><p className="text-xs text-neutral-500">{g.collaboratorId ? "Meta individual" : "Meta da equipe"} · {value}{g.unit === "%" ? "%" : ""} de {g.target}{g.unit === "%" ? "%" : ` ${g.unit}`}</p></div>
                <div className="w-32"><ProgressLine value={att} /></div>
                <Tag tone={attTone(att)}>{att}%</Tag>
              </li>
            );
          })}
        </ul>
      </Panel>
      <Panel title="Ranking da equipe" subtitle="Você vê apenas a posição das colegas" className="mt-6" testId="collab-ranking-panel">
        <RankingTable rows={rows} highlightId={collaboratorId} positionOnly />
      </Panel>
    </div>
  );
}
